{
  "Accessibility Menu": "접근성 메뉴",
  "Reset settings": "설정 초기화",
  "Close": "닫기",
  "Content Adjustments": "컨텐츠 조정",
  "Adjust Font Size": "글꼴 크기 조정",
  "Highlight Title": "제목 강조",
  "Highlight Links": "링크 강조",
  "Readable Font": "읽기 쉬운 글꼴",
  "Color Adjustments": "색상 조정",
  "Dark Contrast": "어두운 대비",
  "Light Contrast": "밝은 대비",
  "High Contrast": "높은 대비",
  "High Saturation": "높은 채도",
  "Low Saturation": "낮은 채도",
  "Monochrome": "단색",
  "Contrast": "대비",
  "Invert Colors": "색상 반전",
  "Tools": "도구",
  "Reading Guide": "읽기 가이드",
  "Stop Animations": "애니메이션 중지",
  "Big Cursor": "큰 커서",
  "Increase Font Size": "글꼴 크기 증가",
  "Decrease Font Size": "글꼴 크기 감소",
  "Letter Spacing": "자간",
  "Line Height": "줄 간격",
  "Font Weight": "글꼴 두께",
  "Dyslexia Font": "난독증 글꼴",
  "Language": "언어",
  "Open Accessibility Menu": "접근성 메뉴 열기",
  "Widget Settings": "위젯 설정",
  "Widget Position": "위젯 위치",
  "Top Left": "왼쪽 상단",
  "Top Center": "상단 중앙",
  "Top Right": "오른쪽 상단",
  "Center Left": "가운데 왼쪽",
  "Center Right": "가운데 오른쪽",
  "Bottom Left": "왼쪽 하단",
  "Bottom Center": "하단 중앙",
  "Bottom Right": "오른쪽 하단",
  "Screen Reader": "스크린 리더",
  "Voice Navigation": "음성 내비게이션",
  "Custom Color": "사용자 지정 색상",
  "Change the site's colors": "사이트 색상 변경",
  "Backgrounds": "배경",
  "Headings": "제목",
  "Contents": "콘텐츠",
  "Reset colors": "색상 초기화",
  "Image Desaturation": "이미지 채도 줄이기",
  "Search languages": "언어 검색",
  "No languages found": "언어를 찾을 수 없습니다",
  "Accessibility Profiles": "접근성 프로필",
  "Motor Impaired": "운동 기능 지원",
  "Big cursor, voice navigation, and no animations.": "큰 커서, 음성 내비게이션, 애니메이션 없음.",
  "Blind": "시각 장애",
  "Screen reader helpers with higher contrast.": "높은 대비의 화면 낭독기 보조 기능.",
  "Color Blind": "색각 보정",
  "High contrast palette with desaturated media.": "고대비 팔레트와 탈채도 미디어.",
  "Dyslexia": "난독증",
  "Friendly font, extra spacing, stronger weight.": "읽기 쉬운 폰트, 넉넉한 간격, 더 굵은 글씨.",
  "Low vision": "저시력",
  "Dark contrast and 130% magnification.": "짙은 대비와 130% 확대.",
  "Cognitive & Learning": "인지 및 학습",
  "Highlights key sections and enables voice help.": "핵심 구역을 강조하고 음성 도움을 활성화합니다.",
  "Seizure & Epileptic": "발작 및 간질",
  "Stops animations and desaturates imagery.": "애니메이션을 중지하고 이미지를 탈채도합니다.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "읽기 가이드, 강조된 링크, 차분한 팔레트.",
  "Widget Size": "위젯 크기",
  "Default": "기본",
  "Medium": "보통",
  "Small": "작게",
  "Color Blindness": "색맹 지원",
  "Protanopia": "제1색각이상 (적색)",
  "Deuteranopia": "제2색각이상 (녹색)",
  "Tritanopia": "제3색각이상 (청색)",
  "Achromatopsia": "전색맹",
  "Simulates and assists users with color vision deficiencies.": "색각 이상이 있는 사용자를 시뮬레이션하고 지원합니다."
}
